// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compact-machine-timeline {
    container: machine-timeline / inline-size;
}

.compact-machine-timeline .timeline-rail-fade {
    min-height: 48px;
}

@container machine-timeline (max-width: 25rem) {
    .compact-machine-timeline .methanol-reformer-timeline-scroll {
        height: 344px;
    }
}

/* Timeline scrollbar (Figma spec): thin grey thumb, no arrow buttons.
   Deliberately no \`scrollbar-width\`/\`scrollbar-color\`: setting either makes Chromium 121+
   switch to the standard (Fluent) scrollbar, which draws arrow buttons and ignores every
   ::-webkit-scrollbar rule below. Mirrors \`.ess-timeline-scroll\` in EssHistoricalInfo.css. */
.methanol-reformer-timeline-scroll::-webkit-scrollbar {
    background: transparent;
    width: 4px;
}

.methanol-reformer-timeline-scroll::-webkit-scrollbar-track {
    background: transparent;
}

.methanol-reformer-timeline-scroll::-webkit-scrollbar-thumb {
    background: #ccc;
    background: var(--bg-subtle-hover, #ccc);
    border: 0;
    border-radius: 2px;
}

.methanol-reformer-timeline-scroll::-webkit-scrollbar-button {
    display: none;
    height: 0;
    width: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/MethanolReformerTimeline/MethanolReformerTimeline.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;;;6FAG6F;AAC7F;IACI,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAwC;IAAxC,wCAAwC;IACxC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,QAAQ;AACZ","sourcesContent":[".compact-machine-timeline {\n    container: machine-timeline / inline-size;\n}\n\n.compact-machine-timeline .timeline-rail-fade {\n    min-height: 48px;\n}\n\n@container machine-timeline (max-width: 25rem) {\n    .compact-machine-timeline .methanol-reformer-timeline-scroll {\n        height: 344px;\n    }\n}\n\n/* Timeline scrollbar (Figma spec): thin grey thumb, no arrow buttons.\n   Deliberately no `scrollbar-width`/`scrollbar-color`: setting either makes Chromium 121+\n   switch to the standard (Fluent) scrollbar, which draws arrow buttons and ignores every\n   ::-webkit-scrollbar rule below. Mirrors `.ess-timeline-scroll` in EssHistoricalInfo.css. */\n.methanol-reformer-timeline-scroll::-webkit-scrollbar {\n    background: transparent;\n    width: 4px;\n}\n\n.methanol-reformer-timeline-scroll::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.methanol-reformer-timeline-scroll::-webkit-scrollbar-thumb {\n    background: var(--bg-subtle-hover, #ccc);\n    border: 0;\n    border-radius: 2px;\n}\n\n.methanol-reformer-timeline-scroll::-webkit-scrollbar-button {\n    display: none;\n    height: 0;\n    width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
